import _ from 'lodash';
import { required, maxLength, minLength } from 'vuelidate/lib/validators';
import FundPerson from '@/app/modules/fund/components/fund-person/fund-person.vue';
import FundAddPersonModal from '@/app/modules/fund/components/fund-add-person-modal/fund-add-person-modal.vue';

export default {
  name: 'fund-members',
  components: {
    FundPerson,
    FundAddPersonModal,
  },
  data: () => ({
    showFundAddMemberModal: false,
  }),
  computed: {
    members() {
      return this.$store.getters['fund/getFund'].members;
    },
    trustee() {
      return this.$store.getters['fund/getFund'].trustee;
    },
    canAddMember() {
      return this.members.length < this.$v.members.$params.maxLength.max;
    },
  },
  methods: {
    backStep() {
      this.$emit('backStep');
    },
    nextStep() {
      this.$emit('nextStep');
    },
    handleAddMember(member) {
      member.isMember = true;
      this.$store.dispatch('fund/updateFundMembers', [...this.members, member]);
    },
    handleDeleteMember(pos) {
      const newMembers = this.members.filter((member, idx) => idx !== pos);

      const deletedMember = this.members.filter((member, idx) => idx === pos)[0];
      const trusteeToUpdateIdx = this.trustee.trustees
        .findIndex(trustee => trustee.uuid === deletedMember.uuid);
      const trusteeUpdated = {
        ...this.trustee.trustees.filter(trustee => trustee.uuid === deletedMember.uuid)[0],
      };
      trusteeUpdated.isMember = false;

      const updatedTrustee = _.cloneDeep(this.trustee);
      updatedTrustee.trustees.splice(trusteeToUpdateIdx, 1, trusteeUpdated);

      this.$store.dispatch('fund/updateFundMembers', [...newMembers]);
      this.$store.dispatch('fund/updateFundTrustee', updatedTrustee);
    },
  },
  validations: {
    members: {
      required,
      maxLength: maxLength(6),
      $each: {
        title: {
          required,
        },
        firstName: {
          required,
          minLength: minLength(2),
        },
        lastName: {
          required,
          minLength: minLength(2),
        },
        dateOfBirth: {
          required,
        },
        sex: {
          required,
        },
      },
    },
  },
};
